import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.8189 14.7189C20.2331 14.7189 20.5689 14.3831 20.5689 13.9689C20.5689 13.5547 20.2331 13.2189 19.8189 13.2189V14.7189ZM6.10481 13.1579L6.8413 13.0161L6.10481 13.1579ZM20.5689 9.24404L19.8352 9.08873L20.5689 9.24404ZM-6.66737e-05 0.75H2.74707V-0.75H-6.66737e-05V0.75ZM2.99257 0.952762L5.36832 13.2996L6.8413 13.0161L4.46555 0.669334L2.99257 0.952762ZM7.0868 14.7189H19.8189V13.2189H7.0868V14.7189ZM4.23807 3.23347H21.3831V1.73347H4.23807V3.23347ZM21.1385 2.9317L19.8352 9.08873L21.3027 9.39936L22.606 3.24233L21.1385 2.9317ZM19.5906 9.28695H6.26087V10.787H19.5906V9.28695ZM21.3831 3.23347C21.2242 3.23347 21.1056 3.08716 21.1385 2.9317L22.606 3.24233C22.7705 2.46503 22.1776 1.73347 21.3831 1.73347V3.23347ZM5.36832 13.2996C5.52685 14.1235 6.2478 14.7189 7.0868 14.7189V13.2189C6.96694 13.2189 6.86395 13.1338 6.8413 13.0161L5.36832 13.2996ZM19.8352 9.08873C19.8107 9.20428 19.7087 9.28695 19.5906 9.28695V10.787C20.4174 10.787 21.1315 10.2083 21.3027 9.39936L19.8352 9.08873ZM2.74707 0.75C2.86693 0.75 2.96992 0.835064 2.99257 0.952762L4.46555 0.669334C4.30702 -0.154551 3.58607 -0.75 2.74707 -0.75V0.75Z",
      fill: "black"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.08042",
      cy: "18.1859",
      r: "1.92222",
      fill: "black"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "17.8851",
      cy: "18.1859",
      r: "1.92222",
      fill: "black"
    }, null, -1)
  ]))]))
}
export default { render: render }